import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function postHeight() {
  // documentElement.scrollHeight is bounded below by the iframe viewport
  // height, which prevents the iframe from ever shrinking. In embed mode
  // body has `height: auto` (no min-height), so body's bounding rect is the
  // true content height — use it as the lower bound. Fall back to
  // documentElement for the non-embed case.
  const bodyRect = document.body.getBoundingClientRect();
  const embed = document.documentElement.classList.contains("embed");
  const height = embed
    ? Math.ceil(bodyRect.height)
    : document.documentElement.scrollHeight;
  window.parent.postMessage({ type: "lovable:height", height }, "*");
}

export function IframeHeightReporter() {
  const location = useLocation();

  useEffect(() => {
    postHeight();
    const raf = requestAnimationFrame(postHeight);
    const t = setTimeout(postHeight, 200);

    // Hantera anchor-scroll inuti iframe: be föräldern skrolla till rätt offset
    const embed = document.documentElement.classList.contains("embed");
    if (embed && location.hash) {
      const id = location.hash.slice(1);
      // Vänta tills DOM är klar
      const scrollT = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const y = Math.max(0, Math.floor(el.getBoundingClientRect().top + window.scrollY));
          window.parent.postMessage({ type: "lovable:scrollto", y }, "*");
          window.parent.postMessage({ type: "lovable:scrollTo", top: y }, "*");
        }
      }, 250);
      return () => {
        cancelAnimationFrame(raf);
        clearTimeout(t);
        clearTimeout(scrollT);
      };
    }

    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t);
    };
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    postHeight();
    const ro = new ResizeObserver(() => postHeight());
    ro.observe(document.body);
    window.addEventListener("load", postHeight);

    // Lyssna även på klick på anchor-länkar (samma sida, ingen route-change)
    const embed = document.documentElement.classList.contains("embed");
    const onClick = (e: MouseEvent) => {
      if (!embed) return;
      const a = (e.target as HTMLElement)?.closest("a");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (!href.startsWith("#") && !href.includes(location.pathname + "#")) return;
      const id = href.split("#")[1];
      if (!id) return;
      // Förhindra intern scroll i iframe (fungerar inte med fast höjd) — låt
      // föräldrasidan skrolla istället.
      e.preventDefault();
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          const y = Math.max(0, Math.floor(el.getBoundingClientRect().top + window.scrollY));
          // Nytt format som WP-sidan lyssnar på
          window.parent.postMessage({ type: "lovable:scrollto", y }, "*");
          // Bakåtkompatibelt format
          window.parent.postMessage({ type: "lovable:scrollTo", top: y }, "*");
        }
      });
    };
    document.addEventListener("click", onClick);

    return () => {
      ro.disconnect();
      window.removeEventListener("load", postHeight);
      document.removeEventListener("click", onClick);
    };
  }, []);

  return null;
}
